export const decodeHtmlEntities = (text: string): string => {
  if (!text) return "";
  return text
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, " ");
};

export const stripHtmlTags = (str: string): string => {
  if (!str) return "";
  return decodeHtmlEntities(str.replace(/<[^>]*>/g, "")).trim();
};
